import { useEffect, useState } from "react";

import { Button, Uploader, useToaster, Message } from "rsuite";
import { Icon } from '@rsuite/icons';

import BasicDropdown from "../../components/inputs/basicDropdown/basicDropdown";
import DoublePanel from "../../components/panels/doublePanel/doublePanel";
import StepsHeader from "./utils/stepsHeader";
import InputVoice from "../../components/inputVoice/InputVoice"

import { getContractsByID } from "../../api/user";
import { useLanguage } from "../../context/localeContext";
import { useTranslation } from "react-i18next";
import { useMessenger } from "../../context/messengerContext";
import { callback_pretense, getPackagesByID } from "../../api/user";
import { getUserIdKey } from "../../utils/userIdPayload";
import { validateForm } from "./utils/validation";
import { MAX_FILE_SIZE, ALLOWED_TYPES } from "./utils/validation";
import applyVoice from "./utils/applyVoice";

import "./createClaim.css";
import BasicInput from "../../components/inputs/basicInput/basicInput";

const PLUS_SVG =
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.00005 1.80005L9.00005 16.2M16.2 9.00005L1.80005 9.00005" stroke="#17C653" stroke-width="2" stroke-linecap="round"/>
    </svg>;

const CLAIM_SVG =
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.54684 13.8279C2.61628 12.2579 2.29079 10.4023 2.63146 8.60931C2.97213 6.81633 3.95553 5.20936 5.39706 4.09007C6.83859 2.97078 8.6391 2.41615 10.4606 2.5303C12.2821 2.64446 13.9992 3.41954 15.2897 4.71004C16.5802 6.00055 17.3553 7.71773 17.4695 9.53921C17.5836 11.3607 17.029 13.1612 15.9097 14.6027C14.7904 16.0442 13.1834 17.0277 11.3905 17.3683C9.5975 17.709 7.74183 17.3835 6.17184 16.4529V16.4529L3.57809 17.1873C3.47182 17.2184 3.35915 17.2203 3.25189 17.1929C3.14462 17.1654 3.04671 17.1097 2.96842 17.0314C2.89013 16.9531 2.83434 16.8552 2.8069 16.7479C2.77946 16.6406 2.78139 16.528 2.81247 16.4217L3.54684 13.8279Z" stroke="url(#paint0_linear_1_3578)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.5 8.75H12.5" stroke="url(#paint1_linear_1_3578)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.5 11.25H12.5" stroke="url(#paint2_linear_1_3578)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <defs>
        <linearGradient id="paint0_linear_1_3578" x1="2.49976" y1="10.0078" x2="17.4842" y2="10.0078" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1_3578" x1="7.5" y1="9.25" x2="12.5" y2="9.25" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1_3578" x1="7.5" y1="11.75" x2="12.5" y2="11.75" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        </defs>
    </svg>;


export default function CreateClaim() {
    const [claimData, setClaimData] = useState({sum: '',});
    const [files, setFiles] = useState([]);
    const toaster = useToaster();

    const [startTime, setStartTime] = useState(new Date());

    const [contracts, setContracts] = useState([]);
    const { userId, platform, close } = useMessenger();
    const { t } = useTranslation('basic');
    const { language } = useLanguage();
    const [errors, setErrors] = useState({});
    const [ voiceData, setVoiceData ] = useState({});
    
    const [ refresh, setRefresh ] = useState(0);
    
    const [loading, setLoading] = useState(false);
    
    const [invoices, setInvoices] = useState([]);
       
    useEffect(() => {
        if (!contracts.length) return;
        if (contracts.length === 1) {
            setClaimData(d => ({...d, contract_number: contracts[0].value}));
        }
    }, [contracts])

    useEffect(() => {  
        if (!claimData.contract_number) return;
          
        getPackagesByID({ platform, userId, contract_number: claimData.contract_number }).then((res) => {
            let formatted = [];

            Object.keys(res).map(k => {
                if (!res[k].from_location || !res[k].to_location) return;
                formatted.push(
                    {
                        label: `${k} / ${res[k]?.from_location} → ${res[k]?.to_location}`,
                        value: k
                    }
                )
            })
            setInvoices(formatted);
        });
    }, [claimData.contract_number]);

    useEffect(() => {
        console.log(voiceData)
        if (!voiceData || !Object.keys(voiceData).length) return;
        setClaimData(d => applyVoice(d, voiceData));
        setRefresh(r => r + 1);
    }, [voiceData]);

    useEffect(() => {
        if (!userId) return;
        getContractsByID({ platform, userId }).then((res) => {
            if (res) {
                setContracts(res.map((contract_number) => ({label: contract_number, value: contract_number})));
            }
        });
    }, [userId])

    useEffect(() => {
        console.log("files", files);
    }, [files])


    const handleFileUpload = (fileList) => {
        const validFiles = fileList.filter((file) => {
            if (file.blobFile.size > MAX_FILE_SIZE) {
                toaster.push(<Message type="error" showIcon>{t("file_exceeds_size")}: {file.blobFile.name}</Message>, { placement: "topCenter", duration: 3000 });
                return false;
            }
            if (!ALLOWED_TYPES.includes(file.blobFile.type)) {
                toaster.push(<Message type="error" showIcon>{t("invalid_file_type")}: {file.blobFile.name}</Message>, { placement: "topCenter", duration: 3000 });
                return false;
            }
            return true;
        });

        setFiles(validFiles.map((file) => file.blobFile));
    };

    return (
        <div className="createClaim">
            <StepsHeader />
            <div className="basicWrapperPadding">
                <DoublePanel secondPanelBody={
                    <div className="claimRows">
                        <BasicInput placeholder={t("your_email")}
                            flexible
                            onChange={(c) => setClaimData({...claimData, email : c})}
                            value={claimData.email}
                            error={errors?.email}
                            />
                        <BasicInput placeholder={t("contact_person_fio")}
                            flexible
                            onChange={(c) => setClaimData({...claimData, contact_face  : c})}
                            value={claimData.contact_face }
                            error={errors?.contact_face}
                            />
                        <BasicInput
                            placeholder={t("required_sum_rub")}
                            flexible
                            onChange={(c) => {
                                if (/^\d*$/.test(c)) {
                                    setClaimData({ ...claimData, sum: c === '' ? '' : parseInt(c) });
                                }
                            }}
                            value={claimData.sum}
                            error={errors?.sum}
                            />
                        <BasicInput placeholder={t("describe_situation")}
                            textarea
                            flexible
                            onChange={(c) => setClaimData({...claimData, description : c})}
                            value={claimData.description  }
                            error={errors?.description}
                            />
                        <Uploader action=""
                            disabled={files.length >= 12}
                            autoUpload={false}
                            onChange={handleFileUpload}
                            listType="picture-text"
                            fileList={
                                files.map((file, index) => ({
                                    name: file.name || `file-${index}`,
                                    fileKey: index,
                                    blobFile: file,
                                    url: file.name.endsWith(".jpg") ||
                                        file.name.endsWith(".png") ||
                                        file.name.endsWith(".jpeg") ?
                                        URL.createObjectURL(file) :
                                        "https://img.freepik.com/premium-vector/blank-file-icon_192037-4133.jpg",
                                }))
                            }
                            >
                            <Button style={{
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                background: "transparent",
                            }}>
                                {PLUS_SVG}
                                <span className="paragraph-16R" style={{color: "var(--success-normal)"}}>{t("attach_files")}</span>
                            </Button>
                        </Uploader>
                    </div>
                } secondPanelHeader={
                    <div className="claimHeader">
                        <Icon as={() => CLAIM_SVG} style={{width: '1rem'}} />
                        <span className="claimHeaderText">
                            <span className="placeNumber paragraph-16M">{t("claim_word")}</span>
                        </span>
                    </div>
                }>
                    <div className="claimRows">
                        <BasicDropdown label={t("contract_number")} placeholder={t("select_contract_number")}
                            data={contracts} onChange={(c) => setClaimData({...claimData, contract_number: c})}
                            value={claimData.contract_number}
                            error={errors?.contract_number}
                            />
                        <BasicDropdown
                            label={t("invoice_number_label")}
                            placeholder={t("select_invoice")}
                            data={invoices}
                            onChange={(val) => setClaimData({ ...claimData, invoice_number: val })}
                            value={claimData.invoice_number}
                        />
                    </div>
                </DoublePanel>
            </div>
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "1rem",
                marginBottom: "2rem",
                gap: "0.5rem"
            }}>
            </div>
            <InputVoice onNavigateForward={async () => {
                const errors = validateForm(claimData, files);
                setErrors(errors);
                console.log(errors);
                
                if (Object.keys(errors).length) {
                    if (Object.keys(errors).length === 1 && errors["email"] === "uncorrect_email_error") {
                        toaster.push(
                            <Message type="error" showIcon>{"Некорректный email"}</Message>,
                            { placement: "topCenter", duration: 3000 }
                        );
                        return;
                    }
                    
                    if (Object.keys(errors).length === 1 && errors["files"] === "files_error") {
                        toaster.push(
                            <Message type="error" showIcon>{t("attach_photo_video")}</Message>,
                            { placement: "topCenter", duration: 3000 }
                        );
                        return;
                    }
                    
                    toaster.push(
                        <Message type="error" showIcon>{t("not_all_required_fields_filled")}</Message>,
                        { placement: "topCenter", duration: 3000 }
                    );
                    return;
                }
                
                const formData = new FormData();
                formData.append('contract_number', claimData.contract_number);
                formData.append('invoice_number', claimData.invoice_number);
                formData.append('email', claimData.email);
                formData.append('contact_face', claimData.contact_face);
                formData.append('sum', claimData.sum);
                formData.append('description', claimData.description);
                formData.append(getUserIdKey(platform), String(userId));
       
                files.forEach((file) => {
                    formData.append('files_data', file);
                });
                
                try {
                    setLoading(true);
                    
                    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/pretense/create_pretense`, {
                        method: 'POST',
                        body: formData,
                    });
                    
                    if (!response.ok) {
                        setLoading(false);
                        console.error('Ошибка:', response.status);
                        toaster.push(
                            <Message type="error" showIcon>{t("request_error")}</Message>,
                            { placement: "topCenter", duration: 3000 }
                        );
                        return;
                    }
                    
                    const result = await response.json();
                    
                    setLoading(false);
                    
                    console.log('Успешно:', result);
                    
                    const metaWithLanguage = {
                        ...claimData,
                        language: language
                    };
                    
                    await callback_pretense({platform, userId, meta: metaWithLanguage, session: {
                        contract_number: claimData.contract_number,
                        start_time: startTime.toISOString(),
                        total_time: new Date().getTime() - startTime.getTime(),
                    }});
                    
                    close();
                } catch (error) {
                    setLoading(false);
                    console.error('Ошибка:', error);
                    toaster.push(
                        <Message type="error" showIcon>{t("request_error")}</Message>,
                        { placement: "topCenter", duration: 3000 }
                    );
                }
            }} ml_page={"prepare_invoice_pretense"} setJsonForm={setVoiceData} loading={loading}/>
        </div>
    );
}